type PathObj = {
    id: number;
    pathId?: string;
};

export function extractIdFromPath(path: string): number {
    return parseInt(path.split('_').pop());
}

export function concatenateIdToPath(pathObj: PathObj): string {
    return `${pathObj.pathId}_${pathObj.id}`;
}

type LocationIds = {
    realmId: number | null;
    zoneId: number | null;
    matrixId: number | null;
};
export function extractIdsFromLocation(path: string): LocationIds {
    const matches = [...Array.from(path.matchAll(/(?:[a-z0-9-]+_(\d+))/g))].map(
        (match) => parseInt(match[1], 10),
    );

    return {
        realmId: matches[0] || null,
        zoneId: matches[1] || null,
        matrixId: matches[2] || null,
    };
}
